import { useTheme } from "@mui/material/styles";
import { Chip } from "@mui/material";
import useStyles from "./styles";
import { ehPessoaFisica, siglaTipoCliente } from "./helpers";

// Selo que identifica um cliente como pessoa física ou jurídica.
//
// Aceita o cliente inteiro (`cliente`) ou só o valor da coluna (`tipoCliente`),
// porque nem todo lugar que precisa do selo tem a linha completa em mãos.
export default function TipoClienteChip({ cliente, tipoCliente, sx = {} }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const alvo = cliente ?? { tipoCliente };
  const pf = ehPessoaFisica(alvo);

  return (
    <Chip
      label={siglaTipoCliente(alvo)}
      size="small"
      sx={{ ...(pf ? styles.chipPf : styles.chipPj), ...sx }}
    />
  );
}
